import { createContext, useContext } from "react";
export const ActuatorConfigurationContext = createContext({});

export const useActuatorConfigurationContext: any = () => {
    return useContext(ActuatorConfigurationContext);
};
